import React, { Component } from 'react';
import { Layout, notification, Icon,Col,Popover  } from 'antd';
import './style/index.less';
import {Link } from 'react-router-dom';
import HeaderCustom from './components/HeaderCustom';
import { receiveData } from './action';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Routes from './routes';
import phone from '@/style/imgs/all/phone.png';
import phone1 from '@/style/imgs/all/phone1.png';
import wx from '@/style/imgs/all/wx.png';
import wx1 from '@/style/imgs/all/wx1.png';
import xcx from '@/style/imgs/all/xcx.png';
import xcx1 from '@/style/imgs/all/xcx1.png';
import tel from '@/style/imgs/all/tel.png';
import tel1 from '@/style/imgs/all/tel1.png';
import ydjyewm from '@/style/imgs/all/yidian.png';
import feimaewm from '@/style/imgs/all/feima.png';
import xcxewm from '@/style/imgs/all/xcxewm.png';
const { Content, Footer } = Layout;

class App extends Component {
    state = {
        collapsed: false,
        hidden:false
    };
    componentWillMount() {
        const { receiveData,history } = this.props;
        const user = JSON.parse(localStorage.getItem('user'));
        user && receiveData(user, 'auth');
        // receiveData({a: 213}, 'auth');
        // fetchData({funcName: 'admin', stateName: 'auth'});
        this.getClientWidth();
        window.onresize = () => {
            this.getClientWidth();
            // console.log(document.body.clientWidth);
        }
    }
    getClientWidth = () => {    // 获取当前浏览器宽度并设置responsive管理响应式
        const { receiveData } = this.props;
        const clientWidth = document.body.clientWidth;
        receiveData({isMobile: clientWidth <= 992}, 'responsive');
    };
    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };
    appOver =(type)=>{
        let stateObj = {};
        stateObj[type]=true;
        this.setState(stateObj);
    }
    appOut =(type)=>{
        let stateObj = {};
        stateObj[type]=false;
        this.setState(stateObj);
    }
    render() {
        // console.log(this.props.auth);
        // console.log(this.props.responsive);
        const { auth, responsive } = this.props;
        return (
            <Layout>
                <Col style={{flexDirection: 'column',backgroundColor:"rgb(245,245,245)" }}>
                    <HeaderCustom   />
                    <Content style={{ overflow: 'initial',backgroundColor:"rgb(245,245,245)" ,paddingBottom:40}}>
                        <Routes auth={auth} />
                    </Content>
                    <Footer style={{ background:"#fff",width:1912}}>

                        <div style={{height:189,overflow:"hidden",marginTop:26}}>
                            <Col>
                                <Col style={{fontSize:14,color:"#333",textAlign:"left"}} offset={4} md={4}>
                                    <Col  className="footTitle">飞马救援</Col>
                                    <Col className="footTitle" style={{marginTop:20}}>合作关系</Col>
                                    <Col className="footTitle" style={{marginTop:16}}><Link to="/feima/cgal"  rel="noopener noreferrer">成功案例</Link></Col>
                                    <Col className="footTitle" style={{marginTop:16}}><Link to="/feima/gywm"  rel="noopener noreferrer">关于我们</Link></Col>
                                    <Col className="footTitle" style={{marginTop:16}}><Link to="/feima/lxwm"  rel="noopener noreferrer">联系我们</Link></Col>
                                </Col>
                                <Col  style={{fontSize:14,textAlign:"left",color:"#333"}}  md={4}>
                                    <Col className="footTitle" >APP下载</Col>
                                    <Col onMouseOver={()=>this.appOver("yidian1")} onMouseOut={()=>this.appOut("yidian1")} style={{cursor:"pointer",color:this.state.yidian1?"#d2a475":"#333",verticalAlign:"middle",marginTop:20,lineHeight:"20px"}}>
                                        <Popover placement="top" content={<div style={{height:200,width:200}}><img src={ydjyewm} alt=""/></div>} title="扫描二维码下载">
                                            <img style={{marginRight:10}} src={this.state.yidian1?phone1:phone} alt=""/>下载一点APP
                                        </Popover>
                                    </Col>
                                </Col>
                                <Col style={{fontSize:14,color:"#333",textAlign:"left"}}  md={4}>
                                    <Col className="footTitle" >关注飞马</Col>
                                    <Col onMouseOver={()=>this.appOver("wx")} onMouseOut={()=>this.appOut("wx")} style={{cursor:"pointer",color:this.state.wx?"#d2a475":"#333",verticalAlign:"middle",marginTop:20,lineHeight:"20px"}}>
                                        <Popover placement="top" content={<div style={{height:200,width:200}}><img src={feimaewm} alt=""/></div>} title="扫描二维码关注">
                                            <img style={{marginRight:10}} src={this.state.wx?wx1:wx} alt=""/>微信公众号
                                        </Popover>

                                    </Col>
                                    <Col onMouseOver={()=>this.appOver("xcx")} onMouseOut={()=>this.appOut("xcx")} style={{cursor:"pointer",color:this.state.xcx?"#d2a475":"#333",verticalAlign:"middle",marginTop:16,lineHeight:"20px"}}>
                                        <Popover placement="top" content={<div style={{height:200,width:200}}><img src={xcxewm} alt=""/></div>} title="扫描二维码关注">
                                            <img style={{marginRight:10}} src={this.state.xcx?xcx1:xcx} alt=""/>微信小程序
                                        </Popover>

                                    </Col>
                                </Col>
                                <Col style={{fontSize:14,color:"#333",textAlign:"left"}} md={4}>
                                    <Col className="footTitle">客服服务</Col>
                                    <Col onMouseOver={()=>this.appOver("zs1")} onMouseOut={()=>this.appOut("zs1")} style={{cursor:"pointer",color:this.state.zs1?"#d2a475":"#333",verticalAlign:"middle",marginTop:20,lineHeight:"20px"}}>
                                        <img style={{marginRight:10}} src={this.state.zs1?tel1:tel} alt=""/>400-070-9995
                                        <Col style={{marginLeft:33}}>24小时救援招商热线</Col>
                                    </Col>
                                    <Col onMouseOver={()=>this.appOver("zs2")} onMouseOut={()=>this.appOut("zs2")} style={{cursor:"pointer",color:this.state.zs2?"#d2a475":"#333",verticalAlign:"middle",marginTop:16,lineHeight:"20px"}}>
                                        <img style={{marginRight:10}} src={this.state.zs2?tel1:tel} alt=""/>13306527651
                                        <Col style={{marginLeft:33}}>招商热线</Col>
                                    </Col>
                                </Col>
                            </Col>
                            <Col style={{clear:"both"}}></Col>
                        </div>
                    </Footer>
                    <Col style={{width:1912,lineHeight:"44px",height:44,fontSize:14,textAlign:"center",background:"#333",color:"#fff"}}>联系地址：杭州下城区费家塘588号7号楼1楼飞马救援 Copyright©杭州必拯汽车服务有限公司 版权所有 ICP许可证号
                        <a style={{color:"#fff"}} href="https://beian.miit.gov.cn">浙ICP备2021025932号</a></Col>
                </Col>
                
                {
                    responsive.data.isMobile && (   // 手机端对滚动很慢的处理
                        <style>
                        {`
                            #root{
                                height: auto;
                            }
                        `}
                        </style>
                    )
                }
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    const { auth = {data: {}}, responsive = {data: {}} } = state.httpData;
    return {auth, responsive};
};
const mapDispatchToProps = dispatch => ({
    receiveData: bindActionCreators(receiveData, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js